import React, { useContext } from 'react';
import { Route, Routes as Switch } from 'react-router-dom';

import AuthContext from '../contexts/AuthContext';
import Account from '../components/account';
import TailLookup from '../components/tails/lookup/TailLookup';
import Users from '../components/Users';
import NewUser from '../components/Users/new';
import EditUser from '../components/Users/edit';
import HowToSpot from '../components/help/HowToSpot';
import Assistance from '../components/help/Assistance';
import Instructions from '../components/help/Instructions';
// import Admin from '../components/Admin';
// import AdminRoutes from './AdminRoutes';
import Statements from '../components/Admin/statements';

const Routes = () => {
  const { role } = useContext(AuthContext);

  return (
    <Switch>
      <Route path="/" element={<TailLookup />} exact />
      <Route path="/account" element={<Account />} exact />
      {'Admin' === role && (
        <Route path="/statements" element={<Statements />} exact />
      )}
      <Route path="/howToSpot" element={<HowToSpot />} exact />
      <Route path="/assistance" element={<Assistance />} exact />
      {'Admin' === role && (
        <>
          <Route path="/users" element={<Users />} exact />
          <Route path="/users/new" element={<NewUser />} exact />
          <Route path="/users/:id/edit" element={<EditUser />} exact />
        </>
      )}
      <Route path="/instructions" element={<Instructions />} exact />
    </Switch>
  );
}

export default Routes;
